(function () {
  'use strict';

  var MAX_PHOTO_BYTES = 20 * 1024 * 1024; // 20 Mo, cf. limite Shopify pour les properties de type fichier

  function init(container) {
    var sectionId = container.dataset.sectionId;
    var productFormId = container.dataset.formId;

    var photoRequired = container.querySelector('[data-maly-portrait-photo-required]');
    var photoInputs = container.querySelectorAll('[data-maly-portrait-photo]');
    var photoError = container.querySelector('[data-maly-portrait-photo-error]');

    var texteInput = container.querySelector('[data-maly-portrait-texte]');
    var texteError = container.querySelector('[data-maly-portrait-texte-error]');

    var charmGroup = container.querySelector('[data-maly-charm-group]');
    var formeSelect = container.querySelector('[data-maly-charm-forme]');
    var formeError = container.querySelector('[data-maly-charm-forme-error]');
    var couleurRadios = container.querySelectorAll('.maly-charm-color-radio');
    var couleurError = container.querySelector('[data-maly-charm-couleur-error]');

    function isCharmVisible() {
      return !!charmGroup && !charmGroup.hidden;
    }

    function clearCharmValues() {
      if (formeSelect) formeSelect.value = '';
      couleurRadios.forEach(function (radio) {
        radio.checked = false;
      });
    }

    // Bascule l'affichage des champs charm. Le conteneur .maly-portrait-perso
    // est rendu en dehors de <variant-selects> (voir product-variant-picker.liquid) :
    // il n'est jamais remplacé par le fetch AJAX que Dawn/Trade déclenche au
    // changement de variante (seuls <variant-selects> et quelques éléments
    // ciblés par ID — prix, stock… — le sont). Les écouteurs posés ici une
    // seule fois au chargement restent donc valides tant que la page vit.
    function setCharmVisibility(visible) {
      if (!charmGroup) return;
      charmGroup.hidden = !visible;
      if (!visible) {
        clearCharmValues();
        markValid(formeSelect, formeError);
        couleurError.hidden = true;
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || data.sectionId !== sectionId) return;
        var variantTitle = (data.variant && data.variant.title) || '';
        setCharmVisibility(variantTitle.toLowerCase().indexOf('charm') !== -1);
      });
    }

    function invalidClassFor(field) {
      if (field.type === 'file') return 'maly-portrait-file--invalid';
      return field.tagName === 'SELECT' ? 'maly-portrait-select--invalid' : 'maly-portrait-input--invalid';
    }

    function markInvalid(field, errorEl) {
      if (field) field.classList.add(invalidClassFor(field));
      if (errorEl) errorEl.hidden = false;
    }

    function markValid(field, errorEl) {
      if (field) {
        field.classList.remove('maly-portrait-input--invalid', 'maly-portrait-select--invalid', 'maly-portrait-file--invalid');
      }
      if (errorEl) errorEl.hidden = true;
    }

    // Une photo dépassant la limite Shopify échouerait silencieusement côté
    // serveur (l'appel /cart/add.js renverrait une erreur générique) : on
    // vérifie donc la taille côté client, dès la sélection, pour prévenir
    // tout de suite plutôt que de laisser échouer l'ajout au panier.
    function oversizedPhotoInput() {
      return Array.prototype.find.call(photoInputs, function (input) {
        return input.files && input.files[0] && input.files[0].size > MAX_PHOTO_BYTES;
      });
    }

    photoInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.files && input.files[0] && input.files[0].size > MAX_PHOTO_BYTES) {
          markInvalid(input, photoError);
        } else {
          markValid(input, photoError);
          photoInputs.forEach(function (other) {
            other.classList.remove('maly-portrait-file--invalid');
          });
        }
      });
    });

    if (texteInput) {
      texteInput.addEventListener('input', function () {
        markValid(texteInput, texteError);
      });
    }
    if (formeSelect) {
      formeSelect.addEventListener('change', function () {
        markValid(formeSelect, formeError);
      });
    }
    couleurRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        couleurError.hidden = true;
      });
    });

    // Validation avant ajout au panier.
    //
    // Important : product-form.js (Dawn/Trade) appelle evt.preventDefault()
    // dès la première ligne de son gestionnaire "submit", puis envoie
    // directement la requête AJAX d'ajout au panier — il n'appelle jamais
    // form.checkValidity()/reportValidity(). L'attribut HTML `required` sur
    // nos champs ne bloque donc rien tout seul, il faut valider nous-mêmes.
    // On écoute 'submit' en phase de CAPTURE sur document (avant que
    // l'écouteur posé directement sur le <form> par product-form.js ne
    // s'exécute en phase cible) afin de pouvoir stopper l'événement à temps,
    // quel que soit l'ordre de chargement des deux scripts.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        // Important : NE PAS lire `form.id` ici. Ce formulaire contient un
        // champ `<input name="id">` (l'id de variante, dans buy-buttons.liquid) ;
        // or un <form> expose ses champs nommés comme propriétés directes,
        // ce qui masque l'IDL `id` natif : `form.id` renvoie alors cet
        // <input>, pas la chaîne d'id du formulaire. Utiliser l'attribut brut.
        if (!form || form.getAttribute('id') !== productFormId) return;

        var firstInvalid = null;

        var oversized = oversizedPhotoInput();
        if (oversized) {
          markInvalid(oversized, photoError);
          firstInvalid = firstInvalid || oversized;
        } else if (photoRequired && (!photoRequired.files || photoRequired.files.length === 0)) {
          markInvalid(photoRequired, photoError);
          firstInvalid = firstInvalid || photoRequired;
        } else {
          photoInputs.forEach(function (input) {
            input.classList.remove('maly-portrait-file--invalid');
          });
          if (photoError) photoError.hidden = true;
        }

        if (texteInput && texteInput.value.trim() === '') {
          markInvalid(texteInput, texteError);
          firstInvalid = firstInvalid || texteInput;
        } else {
          markValid(texteInput, texteError);
        }

        if (isCharmVisible()) {
          if (!formeSelect || formeSelect.value === '') {
            markInvalid(formeSelect, formeError);
            firstInvalid = firstInvalid || formeSelect;
          } else {
            markValid(formeSelect, formeError);
          }

          var couleurChecked = Array.prototype.some.call(couleurRadios, function (radio) {
            return radio.checked;
          });
          if (!couleurChecked) {
            couleurError.hidden = false;
            firstInvalid = firstInvalid || couleurRadios[0] || null;
          } else {
            couleurError.hidden = true;
          }
        }

        if (firstInvalid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          firstInvalid.focus();
        }
      },
      true
    );
  }

  document.querySelectorAll('[data-maly-portrait-perso]').forEach(init);
})();
